import axios from 'axios';
const api = axios.create({ baseURL: '/api', timeout: 10000 });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('semsim_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
api.interceptors.response.use((r) => r, (err) => {
  if (err.response?.status === 401) { localStorage.removeItem('semsim_token'); window.location.href = '/login'; }
  // Every call site across the app does `catch(e){...e.message}` - by default that's axios's
  // generic "Request failed with status code 400", which tells the user nothing. Rewrite it here,
  // once, to the server's actual reason (express-validator's per-field errors, or a plain {error})
  // so every existing catch site automatically starts showing something useful.
  const data = err.response?.data;
  if (data?.errors?.length) err.message = data.errors.map(e => e.msg && e.msg !== 'Invalid value' ? e.msg : `${e.path}: ${e.msg}`).join(' | ');
  else if (data?.error) err.message = data.error;
  return Promise.reject(err);
});
export const authAPI = { login: (email, password) => api.post('/auth/login', { email, password }), me: () => api.get('/auth/me') };
export const alertsAPI = { getActive: () => api.get('/alerts/active'), getHistory: (params) => api.get('/alerts/history', { params }), acknowledge: (id) => api.patch(`/alerts/${id}/acknowledge`), treat: (id) => api.patch(`/alerts/${id}/treat`), resolve: (id, notes) => api.patch(`/alerts/${id}/resolve`, { notes }) };
export const sitesAPI = { getAll: () => api.get('/sites'), getOne: (id) => api.get(`/sites/${id}`), create: (data) => api.post('/sites', data), update: (id, d) => api.put(`/sites/${id}`, d) };
export const buttonsAPI = { getBySite: (siteId) => api.get(`/sites/${siteId}/buttons`), create: (siteId, data) => api.post(`/sites/${siteId}/buttons`, data), update: (id, data) => api.put(`/buttons/${id}`, data), remove: (id) => api.delete(`/buttons/${id}`) };
export const smsAPI = { getBySite: (siteId) => api.get(`/sites/${siteId}/sms-recipients`), create: (siteId, data) => api.post(`/sites/${siteId}/sms-recipients`, data), remove: (id) => api.delete(`/sms-recipients/${id}`) };
export const usersAPI = { getAll: () => api.get('/users'), create: (data) => api.post('/users', data), toggle: (id) => api.patch(`/users/${id}/toggle`) };
export const statsAPI = { get: () => api.get('/stats') };

export const municipalitiesAPI = {
  getAll:        ()        => api.get('/municipalities'),
  getOne:        (id)      => api.get(`/municipalities/${id}`),
  create:        (data)    => api.post('/municipalities', data),
  update:        (id,data) => api.put(`/municipalities/${id}`, data),
  addUser:       (id,data) => api.post(`/municipalities/${id}/users`, data),
  addSite:       (id,data) => api.post(`/municipalities/${id}/sites`, data),
  addSMS:        (id,data) => api.post(`/municipalities/${id}/sms-recipients`, data),
  deleteSMS:     (rid)     => api.delete(`/municipalities/sms-recipients/${rid}`),
};
export default api;
